import { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";
import { NavigationTypes } from "web_myplann/Utils/device";

export const NATIVE_CALCULATOR_SCREENS: Partial<
	Record<CalculatorType, keyof typeof NavigationTypes>
> = {
	[CalculatorType.Mortgage]: NavigationTypes.MortgageCalculatorScreen,
	[CalculatorType.TravelInsurance]:
		NavigationTypes.TravelInsuranceCalculatorScreen,
	[CalculatorType.PropertyInsurance]:
		NavigationTypes.PropertyInsuranceCalculatorScreen,
	[CalculatorType.CarMotoInsurance]:
		NavigationTypes.VehicleInsuranceCalculatorScreen,
	[CalculatorType.ConsumerLoan]: NavigationTypes.ConsumerLoanCalculatorScreen,
	[CalculatorType.PensionAnnuity]:
		NavigationTypes.PensionAnnuityCalculatorScreen,
	[CalculatorType.Refinancing]: NavigationTypes.RefinancingCalculatorScreen,
};

export const SHELL_GATED_CALCULATOR_SCREENS: readonly (keyof typeof NavigationTypes)[] =
	[NavigationTypes.RefinancingCalculatorScreen];
